﻿(function (angular) {
    'use strict';

    angular.module('Toyota.Directives')
        .directive('tyValidCustomerNumber', function Map() {
            return {
                require: 'ngModel',
                link: function (scope, elm, attrs, ctrl) {
                    ctrl.$validators.customernumber = function (modelValue) {
                        if (ctrl.$isEmpty(modelValue)) {
                            // consider empty model valid
                            return true;
                        }

                        return /^[0-9]*$/.test(modelValue);
                    };
                }
            };

        });
})(window.angular);